import { FC, ComponentPropsWithoutRef, PropsWithChildren } from 'react';

import styles from 'bloko/blocks/selectDropdownOption/selectDropdownOption.less';

const SelectDropdownOptionText: FC<ComponentPropsWithoutRef<'span'> & PropsWithChildren> = (props) => (
    <span {...props} className={styles['bloko-select-dropdown-option__text']} />
);

export default SelectDropdownOptionText;
